import {InputFile, InputFileProps} from '@/components/commons/input-file/InputFile'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {FileDropdownMenu} from '@/components/commons/file-dropdown-menu/FileDropdownMenu'
import {UploadedDocument} from '@/types'
import {CSSProperties} from 'react'

interface FileUploadProps {
    document?: UploadedDocument | null
    isLoading?: boolean
    onDeleteFile?: (id: string) => void
    dropDownMenuProps?: {
        triggerWidth?: CSSProperties['width']
    }
    inputFileProps: InputFileProps
}

export const FileUploader = ({
    document,
    isLoading,
    onDeleteFile,
    dropDownMenuProps,
    inputFileProps
}: FileUploadProps) => {
    const handleDeleteFile = (fileId: string) => {
        onDeleteFile?.(fileId)
    }

    return (
        <Flexbox align="flex-end" fullWidth>
            {isLoading ? (
                <Button disabled size="md" shape="square" variant="secondary">
                    <Spinner size={18} />
                </Button>
            ) : document ? (
                <FileDropdownMenu file={document} onDeleteFile={handleDeleteFile} {...dropDownMenuProps} />
            ) : (
                <InputFile {...inputFileProps} />
            )}
        </Flexbox>
    )
}
